import FieldIcon_Popover from "./components/popover/popover";
import FieldPopover from "../../../fields3/generic/popover/popover";
import FieldConfig from "../../proto/field-config";
import FieldIcon_FormValueNotEmpty from "./render/form/value-not-empty";

export default class FieldIcon extends FieldPopover {

    constructor(config:FieldConfig) {
        super(config);

        this.typeLabel          = "Icon";

        this.components.PopoverMenu         = FieldIcon_Popover
        this.components.FormValueNotEmpty   = FieldIcon_FormValueNotEmpty

        // this.components = _.assign({}, this.components, {
        //     PopoverMenu:            FieldIcon_Popover,
        // })
    }

    // return icon class
    getDisplayValue(value: any): any {
        return super.getDisplayValue(value);
    }

}